import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=52043fc5&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./QuillEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuillEditor.vue?vue&type=style&index=0&id=52043fc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52043fc5",
  null
  
)

export default component.exports